import React, {useEffect, useMemo, useRef} from "react";
import {useNavigate} from "react-router-dom";
import "../css/404.css";

const NotFound = () => {
  const navigate = useNavigate();

  const imgRef = useRef<HTMLImageElement>(null);
  const startTimeRef = useRef<number | null>(null);
  const orbitPeriod = 4000; // orbit period in milliseconds

  const stars = useMemo(() =>
    Array.from({length: 300}).map((_, i) => {
      const top = `${Math.random() * 100}%`;
      const left = `${Math.random() * 100}%`;
      const duration = `${0.5 + Math.random()}s`;
      const delay = `${Math.random()}s`;
      const scale = 0.8 + Math.random() * 0.8;
      const blur = 2 + Math.random() * 2;

      return (
        <span
          key={i}
          className="star"
          style={{
            top,
            left,
            transform: `scale(${scale})`,
            animationDuration: duration,
            animationDelay: delay,
            boxShadow: `0 0 ${blur}px rgba(255, 255, 255, 0.8)`,
          }}
        />
      );
    }), []
  );

  useEffect(() => {
    let frameId: number;
    const radius = 25; // orbit radius in pixels
    const animate = (time: number) => {
      // Initialize start time
      if (startTimeRef.current === null) {
        startTimeRef.current = time;
      }
      const elapsed = time - startTimeRef.current;
      // Compute angle so one full orbit takes `orbitPeriod` ms
      const angle = ((elapsed % orbitPeriod) / orbitPeriod) * 2 * Math.PI;
      const x = Math.cos(angle) * radius;
      const y = Math.sin(angle) * radius;
      if (imgRef.current) {
        imgRef.current.style.transform = `translate(-50%, -50%) translate(${x}px, ${y}px)`;
      }
      frameId = requestAnimationFrame(animate);
    };
    frameId = requestAnimationFrame(animate);
    return () => cancelAnimationFrame(frameId);
  }, []);

  return (
    <div
      className="position-fixed top-0 start-0 w-100 vh-100 d-flex flex-column justify-content-center align-items-center gap-5 star-twinkle-bg"
      style={{zIndex: 999, backgroundColor: "var(--color-sigma-bg)"}}>
      <div className="starfield" aria-hidden="true">
        {stars.map(star => star)}
      </div>
      <div className="container-fluid d-flex align-items-center justify-content-center"
           style={{minHeight: "100vh", zIndex: 2, position: "relative"}}>
        <div className="row justify-content-center w-100">
          <div className="col-12 col-md-8 col-lg-6">
            <div className="text-center">
              {/* Error Message */}
              <div className="text-white text-center fw-light">
                <div className="display-5 mb-2">Oops!</div>
                <div className="fs-2">Our network explorer got lost in space</div>
              </div>

              {/* UFO Image Container */}
              <div className="d-flex justify-content-center align-items-end my-5" style={{height: "100%"}}>
                <div
                  className="d-flex justify-content-center align-items-center"
                  style={{width: "250px", height: "250px", overflow: "hidden"}}
                >
                  <img
                    ref={imgRef}
                    src={`${process.env.PUBLIC_URL}/images/bruno-ufo.png`}
                    alt="Guide back to safety"
                    className="img-fluid rounded-circle"
                    style={{
                      position: "absolute",
                      top: "54%",
                      left: "50%",
                      transform: "translate(-50%, -50%)",
                      maxWidth: "25%",
                      maxHeight: "25%",
                      cursor: "pointer",
                    }}
                    onClick={() => navigate("/")}
                  />
                </div>
              </div>

              {/* Instructions */}
              <div className="text-white text-center fw-light fs-3">
                Click the guide dog to bring us home
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
